import { render, staticRenderFns } from "./DashboardEnterpriseLockedWidget.vue?vue&type=template&id=48cc9f56&scoped=true"
import script from "./DashboardEnterpriseLockedWidget.vue?vue&type=script&lang=js"
export * from "./DashboardEnterpriseLockedWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardEnterpriseLockedWidget.vue?vue&type=style&index=0&id=48cc9f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc9f56",
  null
  
)

export default component.exports